import request from '@/utils/request'

// 获取月度统计数据
export function getMonthlyStatistics() {
  return request({
    url: '/sys/statistic/transaction',
    method: 'get'
  })
}

// 获取交易记录列表
export function getTransactionList(params) {
  return request({
    url: '/oms/transaction',
    method: 'get',
    params: {
      page: params.page,
      limit: params.pageSize,
      transactionType: params.transactionType,
      orderType: params.orderType,
      startTime: params.startDate,
      endTime: params.endDate
    }
  })
}

export function exportTransactions(params) {
  console.log('发起导出请求，参数：', params)
  return request({
    url: '/oms/transaction/export',
    method: 'get',
    params: {
      orderType: params.orderType,
      transactionType: params.transactionType,
      startTime: params.startDate,
      endTime: params.endDate
    }
  })
}

export function getTransactionDetail(id) {
  return request({
    url: `/billing/transactions/${id}`,
    method: 'get'
  })
}
